import React from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
// import { Link } from "react-router-dom";
import IndustriesPgBackground from "../../Images/Industries-Page-Background.webp";
import Manufacturing from "../../Images/(Manufacturing)-Industries_Pg.webp";
import Logistics from "../../Images/(Logistics)-Industries_Pg.webp";
import ICT from "../../Images/(ICT)-Industries_Pg.webp";
import Construction from "../../Images/(Construction)-Industries_Pg.webp";
import RealEstate from "../../Images/(RealEstate)-Industries_Pg.webp";
import HealthCare from "../../Images/(HealthCare)-Industries_Pg.webp";
import Education from "../../Images/(Education)-Industries_Pg.webp";
import Security from "../../Images/security.webp";
import TrustAndSafetySection from "./TrustAndSafetySection";
import IndustriesContactSection from "./IndustriesContactSection";

const IndustriesServePage = () => {
  const cardsLeft = [
    {
      title: "Manufacturing & Industrial",
      text: "Optimizing production processes and implementing automation solutions to enhance manufacturing efficiency and competitiveness ",
      img: Manufacturing,
    },
    {
      title: "Logistics & Transportation",
      text: "Smart logistics solutions with route optimization and real-time tracking for seamless supply chain management ",
      img: Logistics,
    },
    {
      title: "Information & Communication Technology (ICT) ",
      text: "Driving digital transformation through innovative software, cloud infrastructure, and emerging technologies ",
      img: ICT,
    },
    {
      title: "Construction & Infrastructure ",
      text: "Smart construction technologies and project management solutions for sustainable infrastructure development",
      img: Construction,
    },
  ];

  const cardsRight = [
    {
      title: " Real Estate & Hospitality",
      text: "Digital platforms and smart building solutions that transform property management and hospitality services ",
      img: RealEstate,
    },
    {
      title: " Healthcare & Biotech ",
      text: "Innovative healthcare technologies and digital health solutions that improve patient care and outcomes ",
      img: HealthCare,
    },
    {
      title: " Education & Training",
      text: "Digital learning platforms and e-learning solutions for modern workforce skill development ",
      img: Education,
    },
    {
      title: "  Defense & Homeland Security ",
      text: "Advanced defense technologies and cybersecurity solutions for critical infrastructure protection",
      img: Security,
    },
  ];
  return (
    <div>
      <Header />
      <section
        className="relative w-full min-h-screen text-white"
        style={{
          backgroundImage: `url(${IndustriesPgBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="pt-[7rem] md:pt-[10rem]">
          <section className="pb-12 px-2 md:px-6 bg-transparent text-gray-800">
            <div className="text-left mb-12 max-w-7xl mx-auto">
              <h2 className="text-4xl font-bold text-[#C99C48]">
                Industries We Serve
              </h2>
              <p className="text-lg text-gray-100 mt-2 max-w-2xl">
                We specialize in high-growth, government-priority sectors:
              </p>
            </div>

            <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-1 md:gap-32">
              {/* Left Side */}
              <div className="flex flex-col gap-6 w-full md:w-1/2">
                {cardsLeft.map((card, index) => (
                  <div
                    key={index}
                    className="flex bg-[#F3F3F3C2] shadow-md rounded-2xl overflow-hidden h-60"
                    data-aos="flip-up"
                  >
                    <div className="w-1/2">
                      <img
                        src={card.img}
                        alt={card.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="w-1/2 p-[6px] md:p-6 flex flex-col justify-start">
                      <h3 className="text-lg md:text-2xl font-semibold mb-1">
                        {card.title}
                      </h3>
                      <p className="text-[#000000] text-sm md:text-[17px]">
                        {card.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Right Side */}
              <div className="flex flex-col gap-6 w-full md:w-1/2 mt-10 md:mt-20">
                {cardsRight.map((card, index) => (
                  <div
                    key={index}
                    className="flex bg-[#F3F3F3C2] shadow-md rounded-2xl overflow-hidden h-60"
                    data-aos="flip-up"
                  >
                    <div className="w-1/2">
                      <img
                        src={card.img}
                        alt={card.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="w-1/2 p-[6px] md:p-6 flex flex-col justify-start">
                      <h3 className="text-lg md:text-2xl font-semibold mb-1">
                        {card.title}
                      </h3>
                      <p className="text-[#000000] text-sm md:text-[17px]">
                        {card.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </section>
      <TrustAndSafetySection />
      <IndustriesContactSection />
      <Footer />
    </div>
  );
};

export default IndustriesServePage;
